import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setSelectedWebsiteSharedUid } from "../../../../features/optifundDashboardSlice";
import OptifundDashboardTabs from "./OptifundDashboardTabs";

interface OptifundDashboardProps {
  userToken: any;
  websiteSharedUid: string;
}

export default function OptifundDashboard({ userToken, websiteSharedUid }: OptifundDashboardProps) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSelectedWebsiteSharedUid(websiteSharedUid));
  }, [websiteSharedUid, dispatch]);

  return <OptifundDashboardTabs userToken={userToken} websiteSharedUid={websiteSharedUid} />;
}
